<template>
  <UiButton
    :type="type"
    :variant="resolvedVariant"
    :size="size"
    :disabled="disabled"
    :loading="loading"
    :full-width="fullWidth"
    @click="handleClick"
  >
    <slot />
  </UiButton>
</template>

<script>
import { Button as UiButton } from './ui/button';

export default {
  name: 'ButtonBase',
  components: {
    UiButton
  },
  props: {
    color: {
      type: String,
      default: 'primary',
      validator: v => [
        'primary',
        'secondary',
        'success',
        'danger',
        'warning',
        'info',
        'light',
        'dark',
        'green',
        'red',
        'blue',
        'gray',
        'white'
      ].includes(v)
    },
    size: {
      type: String,
      default: 'md',
      validator: v => ['sm', 'md', 'lg', 'xl'].includes(v)
    },
    type: {
      type: String,
      default: 'button'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    fullWidth: {
      type: Boolean,
      default: false
    },
    onClick: {
      type: Function,
      default: null
    }
  },
  emits: ['click'],
  computed: {
    resolvedVariant() {
      const colorToVariant = {
        primary: 'default',
        secondary: 'secondary',
        success: 'success',
        danger: 'destructive',
        warning: 'secondary',
        info: 'default',
        light: 'outline',
        dark: 'secondary',
        green: 'success',
        red: 'destructive',
        blue: 'default',
        gray: 'outline',
        white: 'outline'
      };

      return colorToVariant[this.color] || 'default';
    }
  },
  methods: {
    handleClick(event) {
      if (typeof this.onClick === 'function') {
        this.onClick(event);
      }
      this.$emit('click', event);
    }
  }
};
</script>
